import { render, staticRenderFns } from "./ProjectItemPlaceholder.vue?vue&type=template&id=529ab689&scoped=true"
import script from "./ProjectItemPlaceholder.vue?vue&type=script&lang=ts"
export * from "./ProjectItemPlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./ProjectItemPlaceholder.vue?vue&type=style&index=0&id=529ab689&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529ab689",
  null
  
)

export default component.exports